__turbopack_context__.v({
  "checkmark": "LocaleSwitcher-module__N-42vq__checkmark",
  "chevron": "LocaleSwitcher-module__N-42vq__chevron",
  "chevronUp": "LocaleSwitcher-module__N-42vq__chevronUp",
  "code": "LocaleSwitcher-module__N-42vq__code",
  "dropdown": "LocaleSwitcher-module__N-42vq__dropdown",
  "dropdownUp": "LocaleSwitcher-module__N-42vq__dropdownUp",
  "flag": "LocaleSwitcher-module__N-42vq__flag",
  "option": "LocaleSwitcher-module__N-42vq__option",
  "optionCurrent": "LocaleSwitcher-module__N-42vq__optionCurrent",
  "optionFlag": "LocaleSwitcher-module__N-42vq__optionFlag",
  "optionLabel": "LocaleSwitcher-module__N-42vq__optionLabel",
  "trigger": "LocaleSwitcher-module__N-42vq__trigger",
  "triggerOpen": "LocaleSwitcher-module__N-42vq__triggerOpen",
  "wrapper": "LocaleSwitcher-module__N-42vq__wrapper",
});
